import { markNavigationInFlight } from '@aytm/lib/common/rails-post-fetch'

// Reduces a destination to a same-origin path. Absolute, protocol-relative, and
// backslash-prefixed URLs are rejected and replaced with the site root to
// prevent open-redirect abuse. Browsers normalize a leading `/\` (and `\/`) to
// `//`, so `/\evil.com` would otherwise escape to another origin — reject any
// second character that is a slash or backslash.
export function safeSameOriginUrl(url: string): string {
  return url.startsWith('/') && !/^\/[/\\]/.test(url) ? url : '/'
}

// Reduces a destination that is allowed to be absolute — the cross-domain bounce to a
// team subdomain. An absolute URL survives only when its host is one the server named;
// anything else, including an unparseable URL, falls back to the site root. A relative
// destination takes the same-origin rule above.
export function safeHostUrl(url: string, allowedHosts: string[]): string {
  if (!/^https?:\/\//i.test(url)) return safeSameOriginUrl(url)

  let host = ''
  try {
    host = new URL(url).host
  } catch {
    return '/'
  }

  return host && allowedHosts.includes(host) ? url : '/'
}

export function redirectTo(url: string): void {
  markNavigationInFlight() // a late 401 must not reload over this navigation
  window.location.href = safeSameOriginUrl(url)
}

export function redirectToHost(url: string, allowedHosts: string[]): void {
  markNavigationInFlight()
  window.location.href = safeHostUrl(url, allowedHosts)
}
